// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ebcbbWX8O8ikr9gzLVh3 {
  flex: 1;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 100vh;
}

.ebcbbWX8O8ikr9gzLVh3 .s5zJ29UpRr6GdHrWzFfW {
  background-color: #f7f7f7;
  border: 1px none;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ebcbbWX8O8ikr9gzLVh3 .XPX0YcgVbR0au92fHVO8 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 300px;
}

.ebcbbWX8O8ikr9gzLVh3 .q_DXAl6MotMgpnYEhtoM {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 4px;
  position: relative;
}

.ebcbbWX8O8ikr9gzLVh3 .hF5QNuvbURTiHorxFgiC {
  color: #000000;
  font-family: "Noto Sans-Bold", Helvetica;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 24px;
  position: relative;
  text-decoration: underline;
}

.ebcbbWX8O8ikr9gzLVh3 .eQ9bo2STEn4vUdm95a_w {
  color: #33333380;
}

.ebcbbWX8O8ikr9gzLVh3 .vFbpMCMZ8NdVwBejhAfg {
  color: #ed1b2e;
  font-weight: 700;
  text-decoration: unset;
}

.ebcbbWX8O8ikr9gzLVh3 .nWWkgLyTNOdfwEg7szkJ {
  color: #ffffff;
  font-family: "Open Sans-Bold", Helvetica;
  font-weight: 700;
}

.ebcbbWX8O8ikr9gzLVh3 .ujFH5el4ZGmEcYTpwnxa {
  align-items: flex-start;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 16px;
  position: relative;
}

.YhsuOQUPuwnu4Srx6xKm {
  align-items: center;
  background-color: #ffffff;
  border-color: #f7f7f7;
  border-radius: 8px;
  display: flex;
  width: 44px;
  justify-content: center;
  align-items: center;
}

._9t85gMXz0Fpd2DURKYp4 {
  color: #333333;
  flex: 1;
  font-family: Noto Sans;
  font-size: 240px;
  font-weight: Bold;
  line-height: 32px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/verification/Login.module.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,OAAO;EACP,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".container {\n  flex: 1;\n  background-color: #f7f7f7;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n  height: 100vh;\n}\n\n.container .div {\n  background-color: #f7f7f7;\n  border: 1px none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.container .frame_3 {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 300px;\n}\n\n.container .frame_5 {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 4px;\n  position: relative;\n}\n\n.container .kembali {\n  color: #000000;\n  font-family: \"Noto Sans-Bold\", Helvetica;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: 24px;\n  position: relative;\n  text-decoration: underline;\n}\n\n.container .span {\n  color: #33333380;\n}\n\n.container .text_wrapper_4 {\n  color: #ed1b2e;\n  font-weight: 700;\n  text-decoration: unset;\n}\n\n.container .text_wrapper_5 {\n  color: #ffffff;\n  font-family: \"Open Sans-Bold\", Helvetica;\n  font-weight: 700;\n}\n\n.container .nav {\n  align-items: flex-start;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 16px;\n  position: relative;\n}\n\n.number_box {\n  align-items: center;\n  background-color: #ffffff;\n  border-color: #f7f7f7;\n  border-radius: 8px;\n  display: flex;\n  width: 44px;\n  justify-content: center;\n  align-items: center;\n}\n\n.number_otp {\n  color: #333333;\n  flex: 1;\n  font-family: Noto Sans;\n  font-size: 240px;\n  font-weight: Bold;\n  line-height: 32px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ebcbbWX8O8ikr9gzLVh3`,
	"div": `s5zJ29UpRr6GdHrWzFfW`,
	"frame_3": `XPX0YcgVbR0au92fHVO8`,
	"frame_5": `q_DXAl6MotMgpnYEhtoM`,
	"kembali": `hF5QNuvbURTiHorxFgiC`,
	"span": `eQ9bo2STEn4vUdm95a_w`,
	"text_wrapper_4": `vFbpMCMZ8NdVwBejhAfg`,
	"text_wrapper_5": `nWWkgLyTNOdfwEg7szkJ`,
	"nav": `ujFH5el4ZGmEcYTpwnxa`,
	"number_box": `YhsuOQUPuwnu4Srx6xKm`,
	"number_otp": `_9t85gMXz0Fpd2DURKYp4`
};
export default ___CSS_LOADER_EXPORT___;
